/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const card_in = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8 10.156h4.667M1.156 7.978h4.666M4.267 6.422l1.555 1.556-1.555 1.555M1.247 3.5c.227-.304.59-.5.997-.5h11.512C14.443 3 15 3.557 15 4.244v7.012c0 .687-.557 1.244-1.244 1.244H2.244c-.408 0-.77-.197-.997-.5"
    />
  </svg>
)
export default card_in
